module.exports = __webpack_public_path__ + "media/images/logo-ccfde850f80ff24411772c534e45ffad.svg";